import MenuLevelRenderer from './MenuLevelRenderer'
import Wrapper from './Wrapper'

export default function install(Vue) {
  Vue.component(MenuLevelRenderer.name, MenuLevelRenderer)
  Vue.component(Wrapper.name, Wrapper)
}
